import type { LegacyCustomerSearchRow } from '../../mock/legacyCustomerSearch'
import {
  LEGACY_SMS_CUSTOMER_SELECTION,
  LEGACY_SMS_SHOOT_SELECTION,
  type LegacySmsPopupSelectionMessage,
  type LegacySmsRecipientRow,
} from '../../mock/legacySmsRecipients'

export const LEGACY_SMS_POPUP_CHANNEL = 'legacy-sms-popup-selection'

function usable(value: string) {
  const text = value.trim()
  return text && text !== '-' ? text : ''
}

/** C-02의 비식별 Mock 행을 M-01 수신자 행 구조로 변환합니다. */
export function customerSearchRowToSmsRecipient(row: LegacyCustomerSearchRow): LegacySmsRecipientRow {
  const motherPhone = usable(row.motherPhone)
  const fatherPhone = usable(row.fatherPhone)
  const motherName = usable(row.mother)
  const fatherName = usable(row.father)
  const contacts: LegacySmsRecipientRow['contacts'] = []

  if (motherPhone) contacts.push({
    id: `sms-${row.customerNo}-mother`, kind: 'mother', relation: '(엄마)', name: motherName, phone: motherPhone, defaultChecked: true,
  })
  if (fatherPhone) contacts.push({
    id: `sms-${row.customerNo}-father`, kind: 'father', relation: '(아빠)', name: fatherName, phone: fatherPhone,
    defaultChecked: !motherPhone && Boolean(fatherName),
  })

  return {
    id: `sms-${row.customerNo}`,
    mode: 'customer',
    customerNo: row.customerNo,
    babyName: row.baby,
    oopsId: `MOCK-OOPS-${row.customerNo.slice(-3)}`,
    source: row.source,
    hospital: row.hospital,
    postnatalCare: row.postnatalCare,
    additionalSource1: '-',
    additionalSource2: '-',
    contacts,
  }
}

function postSelection(message: LegacySmsPopupSelectionMessage, target: Window | null = window.opener) {
  if (target && !target.closed) {
    target.postMessage(message, window.location.origin)
    return true
  }
  if (typeof BroadcastChannel === 'undefined') return false
  const channel = new BroadcastChannel(LEGACY_SMS_POPUP_CHANNEL)
  channel.postMessage(message)
  channel.close()
  return true
}

/** 고객 검색 팝업에서 선택한 Mock 고객을 부모 M-01 화면으로 전달합니다. */
export function postLegacySmsCustomerSelection(rows: LegacyCustomerSearchRow[]) {
  return postSelection({
    type: LEGACY_SMS_CUSTOMER_SELECTION,
    recipients: rows.map(customerSearchRowToSmsRecipient),
  })
}

/** 촬영 검색 팝업에서 선택한 Mock 촬영을 부모 M-01 화면으로 전달합니다. */
export function postLegacySmsShootSelection(recipients: LegacySmsRecipientRow[]) {
  return postSelection({ type: LEGACY_SMS_SHOOT_SELECTION, recipients })
}
